import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  id?: string;
  size?: 'lg' | 'xl';
  className?: string;
};
export function CTAButton({
  label,
  id,
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const sizing = size === 'xl' ? 'px-6 py-5 text-lg sm:text-xl md:px-10 md:py-6' : 'px-5 py-4 text-base sm:text-lg md:px-8 md:py-5';
  return <a id={id} href={CHECKOUT_URL} className={`group animate-cta-ring inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl border-b-4 border-gold-600 bg-gold-400 text-center font-extrabold uppercase leading-snug tracking-wide text-navy-900 shadow-[0_12px_30px_-8px_rgba(232,192,96,0.7)] transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-gold-300 active:translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-200 ${sizing} ${className}`} data-id="element-113" data-mp="2txjim2h4zd4z">
      <span data-id="element-114" data-mp="199ofghzglbtt">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-115" data-mp="19a7u9pttbk3m" />
    </a>;
}